import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ROOT_URL } from '../../api/ApiConfig';

import { updateUser } from './loginUser';

export const onBoardingApi = createAsyncThunk(
  'business/onboard-business',
  async ({ requestHeaders }, { dispatch, getState, rejectWithValue }) => {
    const { loginToken } = getState();
    const authToken = loginToken?.response?.token;
    console.log("testing", loginToken?.response?.token);
    try {
      const response = await fetch(`${ROOT_URL}/business/onboard-business`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: requestHeaders,
      });
      const result = await response.json();
      console.log("Result", result); // Log the API response

      if (result?.status === 200) {
        const businessId = result.business?.[0]?._id;

        if (businessId) {
          dispatch(updateUser({ user: { business_id: businessId } }));
        }

        // Retrieve the loginToken from localStorage
        const storedLoginToken = localStorage.getItem('persist:root');
        console.log("Stored persist:root string:", storedLoginToken);

        if (storedLoginToken) {
          const parsedRoot = JSON.parse(storedLoginToken);
          let loginToken = JSON.parse(parsedRoot.loginToken);
          console.log("Parsed loginToken before update", loginToken);

          // Update loginToken with the new business_id
          if (loginToken && loginToken.response && loginToken.response.user) {
            loginToken.response.user.business_id = businessId;
            console.log("Updated loginToken", loginToken); // Log the updated loginToken

            // Update the persist:root object with the updated loginToken
            parsedRoot.loginToken = JSON.stringify(loginToken);
            localStorage.setItem('persist:root', JSON.stringify(parsedRoot));
          }
        } else {
          console.error("persist:root is not found in localStorage");
        }
      }
      return result;
    } catch (error) {
      console.error("Error in onBoardingApi:", error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
);

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  isCompleted: false,
  response: [],
  error: null,
};

const OnBoarding = createSlice({
  name: 'OnBoarding',
  initialState,
  reducers: {},
  extraReducers: {
    [onBoardingApi.pending]: (state) => ({
      ...state,
      isLoading: true,
    }),
    [onBoardingApi.fulfilled]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: true,
      isError: false,
      response: action.payload,
    }),
    [onBoardingApi.rejected]: (state, action) => ({
      ...state,
      isLoading: false,
      isSuccess: false,
      isError: true,
      error: action.payload,
    }),
  },
});

export default OnBoarding;